<div class="flex gap-2 items-center">
  {{ params.data.instance_num }}

  @if (params.data.is_self_service) {
    <mat-icon class="text-info" [matTooltip]="'This incident is submitted from the incident submission form.'">rate_review</mat-icon>
  }
</div>
